import { computed, readonly, ref } from 'vue'

/**
 * Tracks in-flight ESG measure / answer mutations so navigation can wait
 * for sectionCompletion to refresh before showing the incomplete warning.
 */
const pendingCount = ref(0)

export function trackEsgSave<T>(promise: Promise<T>): Promise<T> {
  pendingCount.value += 1
  return promise.finally(() => {
    pendingCount.value = Math.max(0, pendingCount.value - 1)
  })
}

export function useEsgSavePending() {
  const isPending = computed(() => pendingCount.value > 0)
  return {
    pendingCount: readonly(pendingCount),
    isPending,
  }
}

export function waitForEsgSaves(timeoutMs = 5000): Promise<void> {
  if (pendingCount.value === 0) return Promise.resolve()
  return new Promise((resolve) => {
    const started = Date.now()
    const tick = () => {
      if (pendingCount.value === 0 || Date.now() - started >= timeoutMs) {
        resolve()
        return
      }
      setTimeout(tick, 50)
    }
    tick()
  })
}
